import { IsDefined } from 'class-validator';

import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { EntityModel } from 'src/core/services/data/models';
import { ContextService } from 'src/core/services/context.service';

export class ApiKeyListDataService extends DataService<typeof Model.General.Logic.ViewModels.ApiKeyItem, Model.General.Logic.ViewModels.ApiKeyItem, ApiKeyItem> {
    private id: number = 0;
    private getNextId(): number {
        this.id--;
        return this.id;
    }

    protected map(entity: Model.General.Logic.ViewModels.ApiKeyItem): ApiKeyItem {
        return new ApiKeyItemModel(entity);
    }

	public static make(context?: ContextService): ApiKeyListDataService {
		return new ApiKeyListDataService(context, ctx => ctx.ApiKeys, false);
    }

	public add(): Promise<ApiKeyItem> {
		const entity = new Model.General.Logic.ViewModels.ApiKeyItem();

		entity.id = this.getNextId();

		return this.create(() => entity);
	}
}

export class ApiKeyItemModel extends EntityModel<Model.General.Logic.ViewModels.ApiKeyItem, ApiKeyItem> implements ApiKeyItem {
    @property<ApiKeyItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@IsDefined()
	@property<ApiKeyItemModel>(o => o.entity.userId, (o, value) => o.entity.userId = value)
	public userId: number;
	
	@property<ApiKeyItemModel>(o => o.entity.userUserName, (o, value) => o.entity.userUserName = value)
	public userUserName: string;

	@property<ApiKeyItemModel>(o => o.entity.expirationDate, (o, value) => o.entity.expirationDate = value)
	public expirationDate: Date;
}



// WEBPACK FOOTER //
// ./src/app/general/api-keys/api-key-list.data.ts